export default __webpack_public_path__ + "static/media/movi-img.2bb164b1.svg";